import $ from 'jquery';
import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { AdGroupColumn as AdGroupColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { InlineEditableColumnPrompt } from './inline-editable/prompt';
import adGroupTemplate from './ad-group.pug';
import { InlineEditableSave } from './inline-editable/save';

export class AdGroupColumn extends CampaignuiBaseColumn {
  constructor({
    i18n,
    scope,
    view,
    permissions,
  }) {
    super({
      ...AdGroupColumnConfig,
      title: i18n.getString('ColumnName_AdGroup'),
      sortable: 'Name',
      editable: true,
      type: 'string',
      bodyClasses: ['grid-column-AdGroup'],
      group: 'freezing',
    });

    this.scope = scope;
    this.i18n = i18n;
    this.view = view;
    this.permissions = permissions;
  }

  pickProperty(item) {
    const { customerId: cid, accountId: aid, userId: uid } = this.scope;
    const {
      Id: adgid,
      Campaign: {
        Id: cmpid,
        CampaignType,
      } = {},
      Name: name,
      AdGroupType,
      $total,
    } = item;

    let pathName = '/campaign/vnext/keywords';
    if (CampaignType === 'Shopping') {
      pathName = '/campaign/vnext/productgroups/hierarchy';
    } else if (CampaignType === 'Hotel') {
      const IsRenameHotelToLodgingEnabled = this.permissions && this.permissions.dynamic && this.permissions.dynamic.IsRenameHotelToLodgingEnabled;
      if (IsRenameHotelToLodgingEnabled) {
        pathName = '/campaign/vnext/propertygroups/hierarchy';
      } else {
        pathName = '/campaign/vnext/hotelgroups/hierarchy';
      }
    } else if (AdGroupType === 'SearchDynamic') {
      pathName = '/campaign/vnext/dynamicadtargets/targets';
    } else if (CampaignType === 'LinkedIn') {
      pathName = '/campaign/vnext/ads';
    }

    const vNextHref = `${pathName}?aid=${aid}&cid=${cid}&uid=${uid}&campaignId=${cmpid}&adGroupId=${adgid}`;

    return {
      cmpid,
      adgid,
      $total,
      name,
      isForVNext: true,
      href: vNextHref,
      ariaLabel: this.i18n.getString('Click to scope to ad group {{adGroupName}}', { adGroupName: name }),
    };
  }

  get template() { return adGroupTemplate; }

  onPrompt({
    event, item, newPosition,
  }) {
    if ($(event.target).is('a')) {
      event.preventDefault();
      return undefined;
    }

    return InlineEditableColumnPrompt({
      position: newPosition,
      item,
      view: this.view,
      i18n: this.i18n,
      fieldName: 'Name',
      saveModel: (updated, editorView) =>
        InlineEditableSave({
          view: this.view,
          i18n: this.i18n,
          fieldName: 'Name',
          updated,
          editorView,
          editorViewCallbackAfterUpdate: () => {
            editorView.trigger('save', updated);
            // update wunderbar
            const response = [{
              Id: item.Id,
              Name: updated.Name,
            }];

            window.App.trigger('adGroupUpdated', { data: response });
          },
        }),
      customClass: `grid-group-${_.result(this.config, 'group', 'other')}`,
    });
  }
}
